import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { signOut } from 'firebase/auth';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import CustomLink from '../CustomLink/CustomLink';
import auth from '../../../firebase.init';
import camera from '../../../images/camera.png';

const Header = () => {
    const [user] = useAuthState(auth);
    const navigate = useNavigate();

    const logout = () => {
        signOut(auth);
        navigate('/login');
    }
    return (
        <div>
            <Navbar collapseOnSelect expand="lg" bg="danger" variant="dark">
                <Container>
                    <Navbar.Brand as={Link} to="/home" className='d-flex flex-nowrap align-items-center justify-content-center'>
                        <img className='me-2' width={25} src={camera} alt="logo" />
                        <span>Wild<span className='text-dark'>life</span> Global</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse className='' id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link as={CustomLink} to="/home" className='px-5 text-uppercase'>Home</Nav.Link>
                            <Nav.Link as={CustomLink} to="/blogs" className='text-uppercase'>Blogs</Nav.Link>
                            <Nav.Link as={CustomLink} to="/about" className='px-5 text-uppercase'>About</Nav.Link>
                        </Nav>
                        <Nav>
                            {
                                user ?
                                    <div>
                                        <span className='me-2 text-capitalize text-light fw-semibold'>{user.displayName}</span>
                                        <button className='btn btn-outline-light text-uppercase' onClick={logout}>Sign Out</button>
                                    </div>
                                    :
                                    <Nav.Link as={CustomLink} to="/login" className='text-uppercase'>Login</Nav.Link>
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;